import { EAccess, EAccessMethod } from "@app/access/access.model";
import { EvideTableColumn, EvideTableColumnComponent, EvideTableColumnType } from "../common/common.model";

export interface INotificationRuleHttpResponse {
  id: number;
  referenceGuid: string;
  name: string;
  description: string;
  ruleType: number;
  ruleTypeName: string;
}

export class NotificationRule {
  constructor(
    public id: number,
    public referenceGuid: string,
    public name: string,
    public description: string,
    public ruleType: number,
    public ruleTypeName: string,
  ) { }

  public static adapt(data: INotificationRuleHttpResponse) {
    return new this(
      data.id,
      data.referenceGuid,
      data.name,
      data.description,
      data.ruleType,
      data.ruleTypeName
    );
  }

  public static createBlank() {
    return new this(0, '', '', '', 0, '');
  }
}

export const NotificationRuleColumns: Readonly<EvideTableColumn[]> = [
  {
    key: 'name',
    type: EvideTableColumnType.Text,
    compType: EvideTableColumnComponent.Input,
    isFormField: true,
    isFormEditableField: true,
    title: 'Rule Name',
    displayValue: true,
    required: true,
    required_error: 'Rule Name is Required',
    sortable: true
  },
  {
    key: 'ruleType',
    type: EvideTableColumnType.Number,
    compType: EvideTableColumnComponent.Dropdown,
    isFormField: true,
    isFormEditableField: true,
    title: 'Rule Type',
    hideInList: true,
    required: true,
    placeholder: 'Please Select Rule Type',
    required_error: 'Rule Type is Required',
    sortable: true
  },
  {
    key: 'ruleTypeName',
    type: EvideTableColumnType.String,
    title: 'Rule Type',
    displayValue: true,
    sortable: true,
    isFormEditableField: false
  },
  {
    key: 'referenceGuid',
    type: EvideTableColumnType.Text,
    compType: EvideTableColumnComponent.Input,
    isFormField: true,
    isFormEditableField: true,
    title: 'Reference Guid',
    displayValue: true,
    required: true,
    required_error: 'Reference Guid is Required',
    sortable: true,
    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$'
  },
  {
    key: 'description',
    type: EvideTableColumnType.Text,
    compType: EvideTableColumnComponent.Textarea,
    isFormField: true,
    isFormEditableField: true,
    title: 'Description',
    displayValue: true,
    required: false,
    sortable: true
  },
  {
    key: 'options',
    type: EvideTableColumnType.Options,
    matIcon: 'more_vert',
    title: 'Options',
    optionMenu: [
      {
        key: 'view_sub',
        type: EvideTableColumnType.Action,
        matIcon: 'fas fa-arrow-right',
        title: 'Rule Parameter',
        accessVisibility: {
          controllerKey: EAccess.NotificationRuleParameter,
          methodKey: EAccessMethod.GetNotificationRuleParameterList
        }
      },
      {
        key: 'edit',
        type: EvideTableColumnType.Action,
        matIcon: 'fa fa-fw fa-trash-alt',
        title: 'Edit',
        accessVisibility: {
          controllerKey: EAccess.NotificationRule,
          methodKey: EAccessMethod.Put
        }
      },
      {
        key: 'delete',
        type: EvideTableColumnType.Action,
        matIcon: 'fa fa-fw fa-trash-alt',
        title: 'Delete',
        accessVisibility: {
          controllerKey: EAccess.NotificationRule,
          methodKey: EAccessMethod.Delete
        }
      }
    ]
  }
];